import * as React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SupportedLanguages } from '../locales';
var correctLanguage = function (lang) {
    var langs = SupportedLanguages.map(function (l) { return l; });
    if (!lang || !langs.includes(lang))
        return 'en';
    return lang;
};
var LanguageSwitch = function () {
    var i18n = useTranslation().i18n;
    var handleChange = React.useCallback(function (event) {
        var lang = event.target.value;
        i18n.changeLanguage(correctLanguage(lang));
    }, [i18n]);
    return (React.createElement(Select, { value: correctLanguage(i18n.language), onChange: handleChange },
        React.createElement(MenuItem, { value: "ja" }, "\u65E5\u672C\u8A9E"),
        React.createElement(MenuItem, { value: "en" }, "English"),
        React.createElement(MenuItem, { value: "ko" }, "Korean"),
        React.createElement(MenuItem, { value: "zh-TW" }, "Chinese (Traditional)"),
        React.createElement(MenuItem, { value: "es" }, "Spanish"),
        React.createElement(MenuItem, { value: "it" }, "Italian"),
        React.createElement(MenuItem, { value: "de" }, "German"),
        React.createElement(MenuItem, { value: "fr" }, "French")));
};
export default LanguageSwitch;
